export default class Person {
    constructor() {
        this.firstName = null;
        this.surname = null;
        this.emailAddress = null;
        this.phoneNumber = null;
        this.isContact = null;
        this.dateOfBirth = null;
        this.dateOfDeath = null;
    }
}